import "../style/card.css";

function Card({ src, style1 }) {
  return (
    <div
      className="teen-card"
      style={{ backgroundImage: `url('${src}')` }}
    ></div>
  );
}

export default Card;
